<template>
  <ui-dialog
    :show="isOpen"
    max-width="623"
    @input="handleClose"
    class="manage-reply-templates-category"
  >
    <template #header>
      <div class="manage-reply-templates-category__header">
        <h3 v-if="mode">
          {{ $t(`message.reviews.replyTemplates.categories.${mode}`) }}
        </h3>
      </div>
    </template>

    <div class="manage-reply-templates-category__body">
      <v-text-field
        v-model="categoryName"
        ref="input"
        :placeholder="
          $t(
            'message.reviews.replyTemplates.categories.categoryNamePlaceholder'
          )
        "
        clearable
        :hide-details="true"
        class="manage-reply-templates-category__input"
        @keyup.enter="handleSave"
      ></v-text-field>
    </div>

    <template #actions>
      <div class="w-100 d-flex justify-center">
        <ui-button
          @click="handleSave"
          :disabled="!categoryName"
          color="primary"
          min-width="130"
        >
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";

export default {
  name: "ReplyTemplatesManageCategoryDialog",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    categoryToEdit: {
      validator: val => ["object", "null"].includes(typeof val)
    },
    mode: {
      type: String,
      default: DIALOG_MANAGE_MODE.ADD,
      validator: val =>
        [DIALOG_MANAGE_MODE.ADD, DIALOG_MANAGE_MODE.EDIT].includes(val)
    }
  },

  data() {
    return {
      categoryName: ""
    };
  },

  watch: {
    async isOpen(newValue) {
      if (newValue) {
        if (this.categoryToEdit && this.categoryToEdit.name) {
          this.categoryName = this.categoryToEdit.name;
        }
        setTimeout(() => {
          this.$refs.input.focus();
        }, 100);
      } else {
        this.categoryName = "";
      }
    }
  },

  methods: {
    handleSave() {
      if (!this.categoryName) return;

      if (this.mode) {
        const modeHandlers = {
          add: () => {
            this.$emit("save", this.categoryName);
          },
          edit: () => {
            const editedCategory = {
              ...this.categoryToEdit,
              name: this.categoryName
            };
            this.$emit("edit", editedCategory);
          }
        };
        modeHandlers[this.mode]();
      }
      this.handleClose();
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-reply-templates-category {
  &__header {
    flex: 1 1 auto;
    text-align: center;
    margin-left: $spacing * 2.5;
  }

  &__body {
    padding: $spacing * 2.5 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__input {
    width: 56%;
  }
}
</style>
